"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPersistedInfo = exports.shouldRemoveTs = void 0;
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const COOKIE_NAME_SOFT_LOGGED = "seth-session-softlogged";
/* -------- HACEMOS LA GESTION DE TIEMPO CON LA COOKIE DE SOFTLOGGED -------- */
const shouldRemoveTs = (persistedInfo) => {
    let res = false;
    try {
        const isProduction = process.env.NEXT_PUBLIC_ENV_NAME === 'prod';
        let softLoggedValue = (0, utils_common_get_cookie_1.default)(COOKIE_NAME_SOFT_LOGGED);
        if (!softLoggedValue && isProduction &&
            (!(persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.source) || (persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.source) !== 'col-extension')) {
            res = true;
        }
    }
    catch (e) {
        console.error(e);
    }
    finally {
        return res;
    }
};
exports.shouldRemoveTs = shouldRemoveTs;
/**
 * Obtiene la información persistida del usuario, verificando si vence el softlogado
 * desde la última actualización. En caso afirmativo, limpia la información.
 * @returns {Object} - Información persistida del usuario.
 */
const getUserPersistedInfo = () => {
    const secureCookieStorageLib = new utils_secure_local_storage_1.default();
    let persistedInfo2Use = {};
    let persistedInfo = secureCookieStorageLib.getItem("ts");
    if (persistedInfo && persistedInfo.ts) {
        const shouldRemove = (0, exports.shouldRemoveTs)(persistedInfo);
        if (shouldRemove) {
            // Limpiar la información si han pasado seis meses
            if (persistedInfo) {
                persistedInfo = {};
                secureCookieStorageLib.removeItem("ts");
            }
        }
        else {
            // Utilizar la información persistida si no han pasado seis meses
            persistedInfo2Use = Object.assign({}, persistedInfo);
        }
    }
    return persistedInfo2Use;
};
exports.getUserPersistedInfo = getUserPersistedInfo;
//# sourceMappingURL=utils.js.map